<template>
  <div class="app-container">
    <el-card class="custom-card mb-20" shadow="never">
      <el-button round type="danger" icon="el-icon-circle-plus-outline" @click="handleAdd()">添加</el-button>
    </el-card>
    <el-table
      :data="list"
      style="width: 100%"
      fit
    >
      <el-table-column align="center" label="广告名称">
        <template slot-scope="{row}">
          <span>{{ row.AdvName }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="广告类型">
        <template slot-scope="{row}">
          <span>{{ row.AdvType | filterAdvType }}</span>
        </template>
      </el-table-column> -->
      <el-table-column align="center" label="图片">
        <template slot-scope="{row}">
          <el-image
            :src="row.AdvOssUrl"
            :preview-src-list="[row.AdvOssUrl]"
            style="width: 100px; height: 100px">
            <div slot="error" class="image-slot" style="font-size: 30px; height: inherit;width:inherit;line-height:100px;">
              <i class="el-icon-picture-outline"/>
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" label="视频">
        <template slot-scope="{row}">
          <el-link :href="row.AdvVideoOssUrl" target="_blank">{{ row.AdvVideoOssUrl }}</el-link>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="{row}">
          <el-link type="primary" @click="handleAdd(row)">编辑</el-link>
          <el-link v-if="row.StatusNo === 'A'" type="danger" @click="handleDisable(row)">禁用</el-link>
          <el-link v-if="row.StatusNo === 'S'" type="primary" @click="handleDisable(row)">启用</el-link>
          <el-link type="danger" @click="del(row)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-card class="custom-card" shadow="never">
      <el-pagination
        v-show="total>0"
        :current-page="listQuery.pageIndex"
        :page-sizes="[10,20,50,100]"
        :page-size="listQuery.pageSize"
        :total="total"
        layout="total, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <dialog-custom
      :centerDialogVisible="visible"
      title="添加/编辑广告"
      @handleCancel="handleCancel"
      @handleConfirm="confirm('form')"
    >
      <el-form ref="form" :model="dataForm" :rules="rules" label-width="100px" class="demo-dataForm">
        <el-form-item label="广告名称" prop="AdvName">
          <el-input v-model="dataForm.AdvName" placeholder="请输入广告名称"/>
        </el-form-item>
        <el-form-item label="广告描述" prop="AdvDescription">
          <el-input v-model="dataForm.AdvDescription" placeholder="请输入广告描述"/>
        </el-form-item>
        <el-form-item hidden label="播放时长" prop="PlayDuration">
          <el-input v-model="dataForm.PlayDuration" placeholder="请输入广告描述">
            <span slot="suffix">秒</span>
          </el-input>
        </el-form-item>
        <el-form-item label="广告图片" prop="AdvOssUrl">
          <upload-com-one :image-url="dataForm.AdvOssUrl" folderName="image" @backData="uploadSuccess($event, 'AdvOssUrl')"/>
        </el-form-item>
        <el-form-item label="广告视频" prop="AdvOssUrl">
          <upload-com-one :image-url="dataForm.AdvVideoOssUrl" accept="video/*" folderName="video" @backData="uploadSuccess($event, 'AdvVideoOssUrl')"/>
        </el-form-item>
      </el-form>
    </dialog-custom>
  </div>
</template>
<script>
import DialogCustom from '@/components/DialogCustom'
import { qryAdvInfo, modAdvInfo, addAdvInfo, activeStopAdv, delAdvInfo } from '@/api/adv'
export default {
  // 组件名称
  name: 'AdvList',
  // 过滤器
  filters: {
    filterAdvType(value) {
      let str = ''
      switch (value) {
        case 'image':
          str = '图片'
          break

        default:
          str = '视频'
          break
      }
      return str
    }
  },
  // 组件
  components: {
    DialogCustom
  },
  // props类型
  props: {
  },
  // 数据
  data() {
    const validNum = (rule, value, callback) => {
      if (!/^\d+$/.test(value)) {
        callback('请输入数字')
      } else {
        callback()
      }
    }
    return {
      visible: false,
      list: [],
      srcList: [],
      listQuery: {
        advId: null,
        advName: null,
        advType: null,
        statusNo: null,
        pageIndex: 1,
        pageSize: 10
      },
      dataForm: {
        AdvId: 0,
        AdvName: null,
        AdvDescription: null,
        AdvType: null,
        AdvOssUrl: null,
        PlayDuration: 60
      },
      rules: {
        PlayDuration: [
          { required: true, message: '请输入播放时长', trigger: 'blur' },
          { required: true, validator: validNum, trigger: 'blur' }
        ],
        AdvName: [
          { required: true, message: '请输入广告名称', trigger: 'blur' }
        ],
        AdvType: [
          { required: true, message: '请选择广告类型', trigger: 'blur' }
        ],
        AdvOssUrl: [
          { required: true, message: '请上传文件', trigger: 'blur' }
        ]
      },
      ossUrl: process.env.OSS_API,
      accept: 'image/png, image/jpg, image/jpeg, image/gif',
      folderName: 'image',
      total: 0
    }
  },
  // 计算属性
  computed: {
  },
  // 计算属性监听
  watch: {
  },
  // 创建时
  created() {
    this.getList()
  },
  // 挂载完毕
  mounted() {
  },
  // 方法
  methods: {
    getList() {
      qryAdvInfo(this.listQuery).then(res => {
        this.list = res.LsList
        this.total = res.TotalRows
      })
    },
    handleAdd(item) {
      console.log(item)
      if (item) {
        for (const key in this.dataForm) {
          this.dataForm[key] = item[key]
        }
      }

      console.log(this.dataForm)
      this.visible = true
    },
    // 禁用
    handleDisable(item) {
      activeStopAdv({ AdvId: item.AdvId, StatusNo: item.StatusNo === 'A' ? 'S' : 'A' }).then(res => {
        this.$message.success('成功')
        this.getList()
      })
    },
    // 删除
    del(item) {
      delAdvInfo({ Id: item.AdvId }).then(res => {
        this.$message.success('删除成功')
        this.getList()
      })
    },
    handleCancel() {
      this.dataForm = {
        AdvId: 0,
        AdvName: null,
        AdvDescription: null,
        AdvType: null,
        AdvOssUrl: null,
        PlayDuration: 60
      }
      this.visible = false
    },
    confirm(dataForm) {
      console.log(dataForm)
      this.$refs[dataForm].validate(valid => {
        console.log(valid)
        if (valid) {
          if (this.dataForm.AdvId) {
            modAdvInfo(this.dataForm).then(res => {
              this.handleCancel()
              this.getList()
            })
          } else {
            addAdvInfo(this.dataForm).then(res => {
              this.handleCancel()
              this.getList()
            })
          }
        }
      })
    },
    uploadSuccess(value, key) {
      console.log(value, key)
      this.dataForm[key] = value
      console.log(this.dataForm)
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e
      this.getList()
    },
    handleCurrentChange(e) {
      this.listQuery.pageIndex = e
      this.getList()
    }
  }
}
</script>

<style lang='less' scoped>
</style>
